import React from "react";
import { useLocation, useParams } from "react-router-dom";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import SubadminFormLayer from "../../components/SubadminFormLayer";

const UpdateSubadminPage = () => {
  const { id } = useParams();
  const { state } = useLocation();
  const initialData = state?.subadmin || null;

  console.log("initialData", initialData)

  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Update Subadmin" />
        <SubadminFormLayer mode="update" id={id} initialData={initialData} />
      </MasterLayout>
    </>
  );
};

export default UpdateSubadminPage;

